import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import currency from "currency.js";
import LineItemDetails from "./LineItemDetails";
import Images from "./image/Images";

export default function LineItemV2(props) {
  const { item, view } = props;

  return (
    <Box sx={{ display: "flex", gap: "1rem" }}>
      <Box sx={{ width: "100px", backgroundColor: "#ECECEC", borderRadius: "4px" }}>
        <Images pics={item.images} />
      </Box>
      <Box sx={{ flexGrow: "1" }}>
        <Typography variant="body1">
          {item.title} <Chip size="small" label={`x ${item.quantity}`} />
        </Typography>
        <LineItemDetails item={item} view={view} />
      </Box>
      <Box sx={{ minWidth: "4rem", textAlign: "right" }}>
        <Typography variant="overline">{currency(item.total || item.price).format()}</Typography>
      </Box>
    </Box>
  );
}
